<app-spinner-overlay></app-spinner-overlay>
<div mat-dialog-content class="dialog-center-compilazione" *ngIf="isReady || isVsme">
  <swiper-container
    [simulateTouch]="false"
    auto-height="true"
    #swiperAmbiti
    (swiperslidechange)="onSlideChange()"
  >
    <swiper-slide class="ambito" *ngFor="let amb of ambiti; let idxAmb = index">
      <div class="titolo">Ambito - {{ amb.titolo }} - {{ amb.descrizione }}</div>

      <swiper-container [simulateTouch]="false" auto-height="true" #swiperTematiche>
        <swiper-slide *ngFor="let tema of amb.tematiche; let idxTem = index">
          <div class="tematiche">
            <div *ngIf="tema.domanda" class="domanda">Tematica - {{ tema.domanda }}</div>

            <div *ngIf="tema.descrizione" class="descrizione">
              {{ tema.descrizione }}
            </div>

            <ng-container *ngIf="tema.tipo === 'scelta_singola'">
              <mat-radio-group
                aria-labelledby="example-radio-group-label"
                class="radio-group"
                [value]="tema?.risposte?.length ? tema.risposte![0] : null"
                (change)="onRadioChange($event, idxAmb, idxTem)"
                #radioGroup="matRadioGroup"
              >
                @for (
                  opz of isVsme ? tema.risposteVsme : tema.opzioni;
                  track $index;
                  let idxOpz = $index
                ) {
                  <ng-container>
                    <mat-radio-button [value]="opz.chiave">
                      {{ opz.valore }}
                    </mat-radio-button>

                    <div
                      class="sotto-opzioni"
                      *ngIf="opz.sottoOpzioni?.length && radioGroup.value === opz.chiave"
                    >
                      <div *ngFor="let opzSec of opz.sottoOpzioni" class="radio-group">
                        <!-- TABELLA -->
                        <ng-container *ngIf="opzSec.tipo === 'dynamic_table'">
                          COMPILAZIONE TABELLA
                        </ng-container>

                        <!-- CHECKBOX -->
                        <ng-container *ngIf="opzSec.tipo === 'checkbox'">
                          <mat-checkbox
                            [value]="opzSec.chiave"
                            [checked]="opzSec.checked"
                            (change)="cambioCheckSottoOpzione($event, opzSec)"
                          >
                            {{ opzSec.valore }}
                          </mat-checkbox>
                        </ng-container>

                        <!-- AZIONE -->
                        <ng-container *ngIf="opzSec.tipo === 'azione'">
                          <mat-label class="descrizione" style="padding-bottom: 15px">{{
                            opzSec.descrizione
                          }}</mat-label>

                          <mat-form-field>
                            <mat-label>Risposta</mat-label>
                            <textarea
                              #textArea
                              matInput
                              [placeholder]="'Risposta'"
                              rows="4"
                              [(ngModel)]="opzSec.risposta"
                            ></textarea>
                            <mat-error appFormError></mat-error>
                          </mat-form-field>
                        </ng-container>

                        <!-- KPI -->
                        <ng-container *ngIf="opzSec.tipo === 'kpi'">
                          <mat-label class="descrizione" style="padding-bottom: 15px">{{
                            opzSec.descrizione
                          }}</mat-label>

                          <div appFormContainer [larghezza]="3">
                            <mat-form-field appFormElement [larghezza]="1">
                              <mat-label>Unità di Misura</mat-label>
                              <mat-select
                                [placeholder]="'Unità di Misura'"
                                [(ngModel)]="opzSec.valoriKpi[0].idUnitaDiRiferimento"
                              >
                                <mat-option
                                  *ngFor="
                                    let um of arrayUm[opzSec.valoriKpi[0].idCategoriaUnitaDiMisura]
                                  "
                                  [value]="um.id"
                                  >{{ um.descrizione }}</mat-option
                                >
                              </mat-select>
                            </mat-form-field>

                            <mat-form-field appFormElement [larghezza]="1">
                              <mat-label>Risposta</mat-label>
                              <input
                                matInput
                                [placeholder]="'Risposta'"
                                [(ngModel)]="opzSec.valoriKpi[0].valoreAttribuito"
                                type="number"
                                appInputNumber
                                step="0.01"
                                inputmode="numeric"
                              />
                              <mat-error appFormError></mat-error>
                            </mat-form-field>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                }
              </mat-radio-group>
            </ng-container>

            @if (
              tema.tipo === 'scelta_multipla' || (isVsme && tema.tipo === 'scelta_multipla_valore')
            ) {
              @for (
                opz of isVsme ? tema.risposteVsme : tema.opzioni;
                let idxOpz = $index;
                track $index
              ) {
                <div
                  class="checkbox-group"
                  [ngStyle]="{ 'margin-top': idxOpz > 0 ? '5px' : '0px' }"
                >
                  <mat-checkbox
                    #checkboxOpz
                    [value]="opz.chiave"
                    [disabled]="disableForm"
                    [checked]="(tema?.risposte || []).indexOf(opz.chiave) > -1"
                    (change)="cambioCheckOpzione($event, tema, opz)"
                  >
                    @if (isVsme && (opz.codiceNormaVsme || opz.descrizioneNormaVsme)) {
                      <div style="display: inline">
                        <span class="descrizione"> {{ opz.valore }}</span>
                        <mat-icon
                          class="material-icons-outlined tooltip-info"
                          [appTooltipOverlay]="tooltipNormaTemplate"
                          [variabiliTemplate]="{
                            codiceNormaVsme: opz.codiceNormaVsme,
                            descrizioneNormaVsme: opz.descrizioneNormaVsme,
                          }"
                          position="right"
                        >
                          info
                        </mat-icon>
                      </div>
                    } @else {
                      <span class="descrizione"> {{ opz.valore }}</span>
                    }

                    <!-- ICONA (MODULO COMPLETO) -->
                    @if (isVsme && opz.moduloCompleto) {
                      <mat-icon
                        style="margin-left: 8px"
                        class="material-icons-outlined icon-m-completo"
                        matTooltip="Modulo Completo"
                      >
                        energy_savings_leaf
                      </mat-icon>
                    }
                  </mat-checkbox>

                  <div
                    class="sotto-opzioni"
                    *ngIf="opz.sottoOpzioni?.length && checkboxOpz.checked"
                  >
                    <div *ngFor="let opzSec of opz.sottoOpzioni" class="radio-group">
                      @if (isVsme) {
                        <!-- TABELLA -->
                        <ng-container *ngIf="opzSec.tipo === 'dynamic_table'">
                          <div class="checkbox-wrapper">
                            <mat-checkbox
                              #checkSottoOpzioneAttiva
                              [checked]="opzSec.checked"
                              [disabled]="disableForm"
                              (change)="sottoOpzAzioneKpiChecked($event, opzSec)"
                            >
                              <div style="display: inline">
                                <span
                                  class="descrizione"
                                  style="padding-bottom: 0px; font-weight: 500"
                                >
                                  {{
                                    opzSec.titoloTabella
                                      ? opzSec.titoloTabella
                                      : 'Compilazione Tabellare'
                                  }}
                                </span>

                                <!-- Icona (figura aziendale) -->
                                <ng-container
                                  [ngTemplateOutlet]="iconaFiguraAziendale"
                                  [ngTemplateOutletContext]="{
                                    idAmbito: amb.id,
                                    idTematica: tema.id,
                                    chiaveRisposta: opz.chiave,
                                    sottoRisposta: opzSec,
                                  }"
                                ></ng-container>

                                <!-- Icona (modulo completo) -->
                                @if (opzSec.moduloCompleto && !opz.moduloCompleto) {
                                  <mat-icon
                                    class="material-icons-outlined icon-m-completo"
                                    matTooltip="Modulo Completo"
                                  >
                                    energy_savings_leaf
                                  </mat-icon>
                                }
                                <!-- Icona (prompt AI FOLLIA) -->
                                @if (!disableForm) {
                                  <ng-container
                                    [ngTemplateOutlet]="iconaFolliaWidget"
                                    [ngTemplateOutletContext]="{
                                      tematica: tema,
                                      sottoRisposta: opzSec,
                                    }"
                                  ></ng-container>
                                }
                              </div>
                            </mat-checkbox>
                          </div>
                          @if (checkSottoOpzioneAttiva.checked) {
                            <app-tabella-cfg-dinamica
                              #cfgTabellaDinamica
                              style="padding: 5px 0px 10px 40px"
                              (variazioneDimensioneCelle)="renderizzaSwiper($event)"
                              (tabellaChange)="aggiornaTabella($event, opzSec)"
                              [tabella]="generaOggettoTabella(opzSec)"
                              [disabilitaHeaderRC]="true"
                              [disabilitaCelle]="disableForm"
                              [nascondiBottoni]="disableForm"
                            ></app-tabella-cfg-dinamica>
                          }
                        </ng-container>
                      }

                      <!-- CHECKBOX -->
                      <ng-container *ngIf="opzSec.tipo === 'checkbox'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [value]="opzSec.chiave"
                            [disabled]="disableForm"
                            [checked]="opzSec.checked"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec)"
                          >
                            @if (isVsme) {
                              <div style="display: inline">
                                <span
                                  class="descrizione"
                                  style="padding-bottom: 0px; font-weight: 500"
                                >
                                  {{ opzSec.valore }}
                                </span>

                                <!-- Icona (figura aziendale) -->
                                <ng-container
                                  [ngTemplateOutlet]="iconaFiguraAziendale"
                                  [ngTemplateOutletContext]="{
                                    idAmbito: amb.id,
                                    idTematica: tema.id,
                                    chiaveRisposta: opz.chiave,
                                    sottoRisposta: opzSec,
                                  }"
                                >
                                </ng-container>

                                <!-- Icona (modulo completo) -->
                                @if (opzSec.moduloCompleto && !opz.moduloCompleto) {
                                  <mat-icon
                                    class="material-icons-outlined icon-m-completo"
                                    matTooltip="Modulo Completo"
                                  >
                                    energy_savings_leaf
                                  </mat-icon>
                                }
                                <!-- Icona (prompt AI FOLLIA) -->
                                @if (!disableForm) {
                                  <ng-container
                                    [ngTemplateOutlet]="iconaFolliaWidget"
                                    [ngTemplateOutletContext]="{
                                      tematica: tema,
                                      sottoRisposta: opzSec,
                                    }"
                                  ></ng-container>
                                }
                              </div>
                            } @else {
                              <span
                                class="descrizione"
                                style="padding-bottom: 0px; font-weight: 500"
                              >
                                {{ opzSec.valore }}
                              </span>
                            }
                          </mat-checkbox>
                        </div>

                        @if (isVsme) {
                          <div
                            appFormContainer
                            [larghezza]="3"
                            *ngIf="checkSottoOpzioneAttiva.checked"
                            style="padding-left: 40px; padding-top: 10px"
                          >
                            <mat-form-field [larghezza]="2" appFormElement>
                              <mat-label>Risposta</mat-label>
                              <textarea
                                #textArea
                                matInput
                                [placeholder]="'Risposta'"
                                rows="4"
                                [disabled]="disableForm"
                                [(ngModel)]="opzSec.risposta"
                              ></textarea>
                              <mat-error appFormError></mat-error>
                            </mat-form-field>
                          </div>
                        }
                      </ng-container>

                      <!-- AZIONE -->
                      <ng-container *ngIf="opzSec.tipo === 'azione'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [checked]="opzSec.checked"
                            [disabled]="disableForm"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec)"
                          >
                            @if (isVsme) {
                              <div style="display: inline">
                                <span
                                  class="descrizione"
                                  style="padding-bottom: 0px; font-weight: 500"
                                >
                                  {{ opzSec.titolo }}
                                </span>

                                <!-- Icona (figura aziendale) -->
                                <ng-container
                                  [ngTemplateOutlet]="iconaFiguraAziendale"
                                  [ngTemplateOutletContext]="{
                                    idAmbito: amb.id,
                                    idTematica: tema.id,
                                    chiaveRisposta: opz.chiave,
                                    sottoRisposta: opzSec,
                                  }"
                                >
                                </ng-container>

                                <!-- Icona (modulo completo) -->
                                @if (opzSec.moduloCompleto && !opz.moduloCompleto) {
                                  <mat-icon
                                    class="material-icons-outlined icon-m-completo"
                                    matTooltip="Modulo Completo"
                                  >
                                    energy_savings_leaf
                                  </mat-icon>
                                }

                                <!-- CONSIGLIATO - elemento consigliato -->
                                @if (opzSec.preCompilazioneInfos) {
                                  <button
                                    mat-icon-button
                                    class="material-icons-outlined icon-m-completo"
                                    [matTooltip]="
                                      'Azione e buona pratica consigliata, vedi maggiori informazioni'
                                    "
                                    (click)="
                                      $event.stopPropagation();
                                      apriPopUpConsigliato(opzSec, 'azione')
                                    "
                                  >
                                    <span class="material-icons-outlined"> emoji_objects </span>
                                  </button>
                                }
                                <!-- Icona (prompt AI FOLLIA) -->
                                @if (!disableForm) {
                                  <ng-container
                                    [ngTemplateOutlet]="iconaFolliaWidget"
                                    [ngTemplateOutletContext]="{
                                      tematica: tema,
                                      sottoRisposta: opzSec,
                                    }"
                                  ></ng-container>
                                }
                              </div>
                            } @else {
                              <span
                                class="descrizione"
                                style="padding-bottom: 0px; font-weight: 500"
                              >
                                {{ opzSec.titolo }}
                              </span>
                            }
                          </mat-checkbox>
                        </div>

                        <mat-label
                          class="descrizione"
                          style="
                            padding-bottom: 15px;
                            color: var(--grigio);
                            padding-left: 45px;
                            font-size: 13px;
                          "
                          >{{ opzSec.descrizione }}</mat-label
                        >

                        <div
                          appFormContainer
                          [larghezza]="3"
                          *ngIf="checkSottoOpzioneAttiva.checked"
                          style="padding-left: 40px"
                        >
                          <mat-form-field [larghezza]="2" appFormElement>
                            <mat-label>Risposta</mat-label>
                            <textarea
                              matInput
                              #textArea
                              [placeholder]="'Risposta'"
                              rows="4"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.risposta"
                            ></textarea>
                            <mat-error appFormError></mat-error>
                          </mat-form-field>
                          @if (opzSec.preCompilazioneInfos && isVsme) {
                            <mat-icon
                              class="material-icons-outlined icona-pre-sel-info"
                              style="padding-top: 55px"
                              [matTooltip]="getTooltip(opzSec.preCompilazioneInfos)"
                            >
                              info
                            </mat-icon>
                          }
                        </div>
                      </ng-container>

                      <!-- KPI -->
                      <ng-container *ngIf="opzSec.tipo === 'kpi'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [checked]="opzSec.checked"
                            [disabled]="disableForm"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec)"
                          >
                            @if (isVsme) {
                              <div style="display: inline">
                                <span
                                  class="descrizione"
                                  style="padding-bottom: 0px; font-weight: 500"
                                >
                                  {{ opzSec.nomeBreve }}
                                </span>

                                <!-- Icona (figura aziendale) -->
                                <ng-container
                                  [ngTemplateOutlet]="iconaFiguraAziendale"
                                  [ngTemplateOutletContext]="{
                                    idAmbito: amb.id,
                                    idTematica: tema.id,
                                    chiaveRisposta: opz.chiave,
                                    sottoRisposta: opzSec,
                                  }"
                                >
                                </ng-container>

                                <!-- Icona (modulo completo) -->
                                @if (opzSec.moduloCompleto && !opz.moduloCompleto) {
                                  <mat-icon
                                    class="material-icons-outlined icon-m-completo"
                                    matTooltip="Modulo Completo"
                                  >
                                    energy_savings_leaf
                                  </mat-icon>
                                }

                                <!-- CONSIGLIATO - elemento consigliato -->
                                @if (opzSec.valoriKpi[0].preCompilazioneInfos) {
                                  <button
                                    mat-icon-button
                                    class="material-icons-outlined icon-m-completo"
                                    [matTooltip]="'KPI consigliato, vedi maggiori informazioni'"
                                    (click)="
                                      $event.stopPropagation(); apriPopUpConsigliato(opzSec, 'kpi')
                                    "
                                  >
                                    <span class="material-icons-outlined"> emoji_objects </span>
                                  </button>
                                }
                                <!-- Icona (prompt AI FOLLIA) -->
                                @if (!disableForm) {
                                  <ng-container
                                    [ngTemplateOutlet]="iconaFolliaWidget"
                                    [ngTemplateOutletContext]="{
                                      tematica: tema,
                                      sottoRisposta: opzSec,
                                    }"
                                  ></ng-container>
                                }
                              </div>
                            } @else {
                              <span
                                class="descrizione"
                                style="padding-bottom: 0px; font-weight: 500"
                              >
                                {{ opzSec.nomeBreve }}
                              </span>
                            }
                          </mat-checkbox>
                        </div>

                        <mat-label
                          class="descrizione"
                          style="
                            padding-bottom: 15px;
                            color: var(--grigio);
                            padding-left: 45px;
                            font-size: 13px;
                          "
                          >{{ opzSec.descrizione }}</mat-label
                        >

                        <div
                          appFormContainer
                          [larghezza]="3"
                          style="padding-left: 40px"
                          *ngIf="checkSottoOpzioneAttiva.checked"
                        >
                          <mat-form-field appFormElement [larghezza]="1">
                            <mat-label>Unità di Misura</mat-label>
                            <mat-select
                              [placeholder]="'Unità di Misura'"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.valoriKpi[0].idUnitaDiRiferimento"
                            >
                              <mat-option
                                *ngFor="
                                  let um of arrayUm[opzSec.valoriKpi[0].idCategoriaUnitaDiMisura]
                                "
                                [value]="um.id"
                                >{{ um.descrizione }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field appFormElement [larghezza]="1">
                            <mat-label>Risposta</mat-label>
                            <input
                              matInput
                              [placeholder]="'Risposta'"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.valoriKpi[0].valoreAttribuito"
                              type="number"
                              appInputNumber
                              step="0.01"
                              inputmode="numeric"
                            />
                            <mat-error appFormError></mat-error>
                          </mat-form-field>
                          <!-- Icona (modulo completo) -->
                          @if (opzSec.valoriKpi[0].preCompilazioneInfos && isVsme) {
                            <mat-icon
                              class="material-icons-outlined icona-pre-sel-info"
                              [matTooltip]="getTooltip(opzSec.valoriKpi[0].preCompilazioneInfos)"
                            >
                              info
                            </mat-icon>
                          }
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </swiper-slide>
      </swiper-container>
    </swiper-slide>
  </swiper-container>
</div>
@if (isAutovalutazione) {
  <div
    mat-dialog-actions
    class="dialog-footer-cont"
    style="justify-content: space-between"
    [ngStyle]="{ 'justify-content': isVsme ? 'flex-end' : 'space-between' }"
  >
    <div style="display: flex; column-gap: 10px">
      <div>
        <button mat-flat-button color="accent" (click)="indietro()" class="accent-button">
          {{ currentSlideIndex === 0 ? 'Chiudi' : 'Indietro' }}
        </button>
      </div>
      <div>
        <button
          mat-flat-button
          color="primary"
          (click)="avanti()"
          class="primary-button"
          #btnAvanti
          [disabled]="
            !ambiti[indexAmbitoCorrente].tematiche[indexTematicaCorrente].risposte?.length
          "
        >
          {{ currentSlideIndex + 1 === totTematiche ? 'Fine' : 'Avanti' }}
        </button>
      </div>
    </div>

    <div class="index-paginator">{{ currentSlideIndex + 1 }}/{{ totTematiche }}</div>
  </div>
}

<!-- FIGURA AZIENDALE DI ASSEGNAMENTO -->
<ng-template
  #iconaFiguraAziendale
  let-idAmbito="idAmbito"
  let-idTematica="idTematica"
  let-chiaveRisposta="chiaveRisposta"
  let-sottoRisposta="sottoRisposta"
>
  <button
    *ngIf="sottoRisposta.checked"
    mat-icon-button
    aria-label="Associa Figura Aziendale"
    class="icona-figura"
    [disabled]="disableForm"
    [matTooltip]="toolTipFigura(sottoRisposta?.figura)"
    style="vertical-align: middle"
    (click)="
      $event.stopPropagation();
      associaFiguraAziendale(
        idAmbito,
        idTematica,
        chiaveRisposta,
        sottoRisposta,
        sottoRisposta?.figura
      )
    "
  >
    <mat-icon
      class="material-icons-outlined"
      [ngClass]="{
        'blue-icon': sottoRisposta?.figura?.id,
        'default-icon': !sottoRisposta?.figura?.id,
      }"
    >
      person
    </mat-icon>
  </button>
</ng-template>

<ng-template
  #tooltipNormaTemplate
  let-codiceNormaVsme="codiceNormaVsme"
  let-descrizioneNormaVsme="descrizioneNormaVsme"
>
  <div>
    <span style="font-weight: 500"
      >{{ codiceNormaVsme }} -
      <span style="font-size: 12px; font-weight: normal !important">{{
        descrizioneNormaVsme
      }}</span></span
    >
  </div>
</ng-template>

<!-- FOLLIA WIDGET -->
<ng-template #iconaFolliaWidget let-tematica="tematica" let-sottoRisposta="sottoRisposta">
  @if (sottoRisposta.checked && isIntegrazioneAI) {
    <app-follia-icon-for-element
      [elemento]="getElementoForAI(sottoRisposta)"
      [tipoElemento]="getTipoElemento(sottoRisposta.tipo)"
      [tematica]="getElementoForAITematica(tematica)"
    ></app-follia-icon-for-element>
  }
</ng-template>
